export default __webpack_public_path__ + "static/media/back-button.709d3c75.svg";